'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Card = exports.NotificationIcon = exports.CardAction = exports.CardButton = exports.Placeholder = undefined;

var _templateObject = _taggedTemplateLiteral(['\n  position: relative;\n  width: 88px;\n  height: 88px;\n  background: url(', ');\n  background-repeat: no-repeat;\n  background-size: 100%;\n  margin: 24px auto;\n'], ['\n  position: relative;\n  width: 88px;\n  height: 88px;\n  background: url(', ');\n  background-repeat: no-repeat;\n  background-size: 100%;\n  margin: 24px auto;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  background: none;\n  border: 0;\n  cursor: pointer;\n  outline: 0;\n  padding: 0;\n  text-decoration: none;\n  width: 100%;\n'], ['\n  background: none;\n  border: 0;\n  cursor: pointer;\n  outline: 0;\n  padding: 0;\n  text-decoration: none;\n  width: 100%;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  color: #404040;\n  font-size: 14px;\n  text-align: center;\n'], ['\n  color: #404040;\n  font-size: 14px;\n  text-align: center;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  position: absolute;\n  top: -30px;\n  right: 0;\n  font-size: 24px;\n  color: ', ';\n'], ['\n  position: absolute;\n  top: -30px;\n  right: 0;\n  font-size: 24px;\n  color: ', ';\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  width: 100%;\n  box-sizing: border-box;\n  position: relative;\n'], ['\n  width: 100%;\n  box-sizing: border-box;\n  position: relative;\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _placeholderVehicle = require('../../assets/images/placeholder-vehicle.png');

var _placeholderVehicle2 = _interopRequireDefault(_placeholderVehicle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Placeholder = exports.Placeholder = _styledComponents2.default.div(_templateObject, _placeholderVehicle2.default);

Placeholder.displayName = 'Placeholder';
var CardButton = exports.CardButton = _styledComponents2.default.button(_templateObject2);

CardButton.displayName = 'CardButton';
var CardAction = exports.CardAction = _styledComponents2.default.div(_templateObject3);

CardAction.displayName = 'CardAction';
var NotificationIcon = exports.NotificationIcon = _styledComponents2.default.i(_templateObject4, function (props) {
  return props.theme.color[props.variant];
});

NotificationIcon.displayName = 'NotificationIcon';
var Card = exports.Card = _styledComponents2.default.div(_templateObject5);
Card.displayName = 'Card';


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-card/styles.js
// module id = 2893
// module chunks = 4